import React from 'react';
import { Col } from 'antd';
import { HomeOutlined } from '@ant-design/icons';
const NavItem = (props) => {
    const { href, children = <HomeOutlined />, text, ...others } = props;
    return (
        <Col span={6}
            xs={{ flex: '100%' }}
            sm={{ flex: '50%' }}
            md={{ flex: '40%' }}
            lg={{ flex: '20%' }}
            xl={{ flex: '10%' }}
            style={{marginBottom: '12px'}}
        >
            <a {...others} href={href || 'javascript:;'}>
                <div style={{padding: '10px', margin: 'auto', width: '50px', height: '50px', border: '1px solid #cccccc', borderRadius: '10px' }}>
                    {children}
                </div>
                <h3 style={{fontSize: '12px', margin: '6px 0 0 0', textAlign: 'center', overflow: 'hidden'}}>{text}</h3>
            </a>
        </Col>
        
    )
}

export default NavItem;